module.exports = __webpack_public_path__ + "static/media/43_A.fd84815a.png";